export const getErrorMessage = (error: any) =>
  error.response && error.response.data && error.response.data.errorMessage;
